import React, { useEffect } from 'react';
import './style/VideoModal.css';
import { FaTimes } from 'react-icons/fa';

function VideoModal({ isOpen, onClose }) {
  // Lock scroll body quand modal ouvert
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  // Fermer avec Échap
  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="video-modal-overlay"
      onClick={onClose}
      aria-modal="true"
      role="dialog"
    >
      <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="video-close-btn" onClick={onClose} aria-label="Close">
          <FaTimes size={18} />
        </button>

        <video controls autoPlay className="video-player" playsInline>
          <source src="/video/intro.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  );
}

export default VideoModal;
